class Tactic {
    constructor(age, name, units, valueText, effect)
    {
        this.age = age;
        this.name = name;
        this.units = units; // [infantry, cavalry, artillery]
        this.valueText = valueText;
        this.effect = effect;
    }

    GetAge() {
        return this.age;
    }

    GetName() {
        return this.name;
    }

    GetUnits() {
        return this.units;
    }

    GetValueText() {
        return this.valueText;
    }
    
    GetText = this.GetValueText;

    GetEffects = () => this.effect;
}

module.exports = Tactic;